export {useDrag1D} from '../../../src/utils/useDrag1D';
